import React, { useEffect } from "react";
import { useHistory, Link } from 'react-router-dom';
import styles from "../../assets/containers/blockPage.module.css";
import Header from "../../components/@header/header";
import LessonCard from "./lessonCard";
import {useAppGlobalConfig} from "../../providers/AppGlobalConfigContext";
import { t } from "../../lib/i18n";


const BlockPage = props => {

  const { batch } = props.location;
  const {isEmbedMode, fireNavigationEvents, setBatchData} = useAppGlobalConfig();

  const history = useHistory();
  let lessons = JSON.parse(localStorage.getItem('lessons'));
  let blockName = localStorage.getItem('blockName');

  useEffect(() => {

    if (!lessons || lessons.length === 0) {
      history.push(`${isEmbedMode?'/embeddable/home':'/classes/list'}`);
    }
  }, [lessons, history]);

  useEffect(() => {
    fireNavigationEvents(`/embeddable/lessonsList`, blockName);
    setBatchData(batch);
  }, []);

  return (
    lessons && lessons.length > 0 &&
    <div className={!isEmbedMode ? `background-image` : ''} style={{minHeight: "calc(100vh - 6rem)"}} >

      {!isEmbedMode && (
          <div>
            <Header menuLanguage={true}/>
          </div>
      )}

      <div className={ !isEmbedMode ? styles["content-container"] : ''} >

        {!isEmbedMode && (
          <div className={styles["breadcrumb"]}>
            <Link to="/classes/list">{t("Home")}</Link>
            <Link to="/lessonsList">{t("Lessons")}</Link>
          </div>
        )}

        <div className={styles["block-container"]} >
          {
            lessons.map((lesson, groupIndex) => (
              <LessonCard key={groupIndex} lesson={lesson} groupIndex={groupIndex}/>  
            ))
          }
        </div>
      </div>
    </div>
  );
};

export default BlockPage;
